import { render } from "./MyInput.vue?vue&type=template&id=0d611140&scoped=true"
import script from "./MyInput.vue?vue&type=script&lang=js"
export * from "./MyInput.vue?vue&type=script&lang=js"

import "./MyInput.vue?vue&type=style&index=0&id=0d611140&lang=scss&scoped=true"

import exportComponent from "D:\\Front-end\\vuechat\\app-ua-truth-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d611140"]])

export default __exports__